class CollectionDescription extends HTMLElement {
  connectedCallback() {
    this.line = this.getAttribute('data-line');
    this.line_color = this.getAttribute('data-line-color');
    this.showMoreLabel = 'Mehr anzeigen';
    this.showLessLabel = 'Weniger anzeigen';
    this.generateNavigationMenu();
  }

  renderLinkIcon(node) {
    const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const iconPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );

    iconSvg.setAttribute('fill', 'none');
    iconSvg.setAttribute('width', 7);
    iconSvg.setAttribute('height', 11);
    iconSvg.setAttribute('viewBox', '0 0 7 11');
    if (this.line) {
      iconSvg.setAttribute('stroke', this.line_color);
    } else {
      iconSvg.setAttribute('stroke', '#3C3C3E');
    }

    iconPath.setAttribute(
      'd',
      'M0.699219 10.3462L5.46038 6.03848L0.699219 1.50403'
    );
    iconPath.setAttribute('stroke-width', '1.5');

    iconSvg.appendChild(iconPath);

    return node.appendChild(iconSvg);
  }

  generateNavigationMenu() {
    const headings = Array.from(this.querySelectorAll('h3, h4, h5'));

    if (headings.length === 0) {
      console.warn('Keine Absätze vorhanden');
      return;
    }

    const navList = document.createElement('ul');
    const navParent = this.querySelector('.ds-content-navigation');

    if (!navParent || navParent.querySelector('ul')) {
      return;
    }

    const sectionId = this.closest('.shopify-section')?.id || 'collection-description';
    navList.id = `${sectionId}-navigation`;

    let counter = 0;
    headings.forEach((heading) => {
      const headingId = `${sectionId}-nav-${counter}`;
      heading.id = headingId;
      const listItem = document.createElement('li');
      const anchor = document.createElement('a');
      this.renderLinkIcon(listItem);
      anchor.textContent = heading.textContent.trimStart();
      anchor.href = `#${heading.id}`;
      listItem.appendChild(anchor);
      navList.appendChild(listItem);
      counter++;
    });

    navParent.appendChild(navList);

    if (headings.length > 3) {
      const toggleButton = document.createElement('button');
      toggleButton.type = 'button';
      toggleButton.className = 'ds-content-navigation__toggle';
      toggleButton.textContent = this.showMoreLabel;
      toggleButton.setAttribute('aria-controls', navList.id);
      toggleButton.setAttribute('aria-expanded', 'false');

      toggleButton.addEventListener('click', () => {
        const isExpanded = navParent.classList.toggle('is-expanded');
        toggleButton.textContent = isExpanded
          ? this.showLessLabel
          : this.showMoreLabel;
        toggleButton.setAttribute('aria-expanded', String(isExpanded));
      });

      navParent.appendChild(toggleButton);
    }
  }
}

if (!window.customElements.get("collection-description")) {
  customElements.define('collection-description', CollectionDescription);
}
